export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  author: string;
  publishDate: string;
  readTime: string;
  image: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    slug: '2026-caodi-jingji-quanguo-sai',
    title: '2026草地竞技全国赛报名正式开启，总奖金池突破百万',
    excerpt: '一年一度的草地竞技全国大赛即将拉开帷幕，本届赛事规模空前，覆盖全国32个城市，总奖金池达到120万元。报名通道现已全面开通，期待你的加入！',
    content: `<p>一年一度的<strong>草地竞技全国大赛</strong>即将拉开帷幕！本届赛事规模空前，覆盖全国32个城市，总奖金池达到120万元。报名通道现已全面开通。</p>
    <h2>赛事亮点</h2>
    <p>本届赛事首次引入<strong>实时数据追踪系统</strong>，每位选手的表现数据都将被精确记录和分析。观众可以通过官方平台实时查看选手排名和比赛进程。</p>
    <p>赛事分为<strong>预选赛、区域赛、全国总决赛</strong>三个阶段。预选赛将于9月1日起在全国各大赛区同步开启，区域赛定于10月中旬举行，全国总决赛将于11月底在北京国家体育场隆重举办。</p>
    <h2>参赛资格</h2>
    <p>年满18周岁的草类竞技爱好者均可报名参赛。报名时需提供有效身份证明和近期体检报告。每位选手只能代表一个赛区参赛。</p>
    <h2>奖励设置</h2>
    <p>全国总冠军将获得<strong>50万元现金奖励</strong>及专属冠军奖杯。亚军和季军分别获得30万元和15万元奖励。此外，各赛区前三名也将获得丰厚奖金和荣誉证书。</p>
    <p>报名截止日期为8月31日，名额有限，建议尽早报名！</p>`,
    category: 'caodi-jingji',
    categoryName: '草地竞技',
    author: '赛事组委会',
    publishDate: '2026-08-10',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Grand%20stadium%20with%20athletes%20competing%20on%20vast%20green%20grass%20field%2C%20championship%20event%20atmosphere%2C%20large%20crowd%20watching%2C%20bright%20sunlight%2C%20professional%20sports%20photography%2C%20clean%20composition%2C%20dramatic%20wide%20angle&width=1200&height=600&seq=article-nationwide-01&orientation=landscape',
    tags: ['全国赛', '报名', '奖金'],
  },
  {
    slug: 'caoyuan-saidai-xinshou-gonglue',
    title: '草园赛道新手攻略：从零开始的通关指南',
    excerpt: '刚接触草园赛道？别担心！这份详细的新手攻略将带你从基础操作到进阶技巧，手把手教你如何在草园赛道中取得优异成绩。',
    content: `<p>刚接触<strong>草园赛道</strong>？别担心！这份详细的新手攻略将带你从基础操作到进阶技巧，手把手教你如何在草园赛道中取得优异成绩。</p>
    <h2>基础装备准备</h2>
    <p>进入草园赛道前，你需要准备以下装备：专业草地跑鞋（推荐选择防滑鞋底）、透气运动服、护膝和护腕。建议携带至少1升饮用水以保持体能。</p>
    <h2>赛道地图解析</h2>
    <p>草园赛道共设有<strong>12个关卡</strong>，包含草地冲刺、泥沼穿越、障碍攀爬等多样化挑战。每个关卡都有特定的通关技巧和最佳路线。我们建议新手先熟悉前6个基础关卡，再逐步挑战高难度区域。</p>
    <h2>体能分配策略</h2>
    <p>合理分配体能是通关的关键。建议采用<strong>「三七法则」</strong>：前30%的赛程保持匀速，中间40%适当加速，最后30%全力冲刺。切记不要在开局就耗尽体力。</p>
    <h2>常见问题</h2>
    <p>新手最常见的错误是<strong>忽视热身</strong>和<strong>装备选择不当</strong>。赛前务必进行至少15分钟的全面热身，并根据天气情况选择合适的装备。</p>
    <p>祝你草园赛道之旅顺利！</p>`,
    category: 'caoyuan-saidai',
    categoryName: '草园赛道',
    author: '资深教练 李明',
    publishDate: '2026-08-08',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Beginner%20athlete%20training%20on%20grassy%20obstacle%20course%20with%20coach%20guidance%2C%20natural%20meadow%20setting%20with%20soft%20sunlight%2C%20supportive%20training%20atmosphere%2C%20clean%20editorial%20photography%2C%20warm%20green%20tones&width=1200&height=600&seq=article-xinshou-01&orientation=landscape',
    tags: ['新手攻略', '赛道指南', '技巧'],
  },
  {
    slug: 'ludi-tiaozhan-qinzi-huodong',
    title: '绿地挑战亲子专场：全家一起享受草地竞技乐趣',
    excerpt: '绿地挑战推出全新亲子专场活动，专为家庭设计的趣味竞技项目，让大人和孩子在绿地上共同体验竞技的快乐，增进亲子感情。',
    content: `<p><strong>绿地挑战</strong>推出全新亲子专场活动！专为家庭设计的趣味竞技项目，让大人和孩子在绿地上共同体验竞技的快乐，增进亲子感情。</p>
    <h2>活动安排</h2>
    <p>亲子专场每周六上午9点至下午4点在城市公园绿地区域举行。活动包含<strong>亲子接力赛、草地寻宝、趣味障碍跑</strong>等六个项目。每个项目都经过专业设计，确保安全且富有趣味性。</p>
    <h2>适合年龄段</h2>
    <p>活动面向<strong>6至14岁</strong>儿童及其家长开放。根据年龄分为少年组（6-10岁）和青少年组（11-14岁），确保竞技公平性。</p>
    <h2>报名方式</h2>
    <p>可通过官方网站或线下服务点报名。每场限30组家庭参与，建议提前一周预约。报名费用为每组家庭198元，包含保险和活动装备。</p>
    <h2>安全保障</h2>
    <p>每场活动配备<strong>专业教练团队</strong>和<strong>医疗急救人员</strong>，所有设施均符合国家安全标准。家长可放心让孩子参与。</p>`,
    category: 'ludi-taofa',
    categoryName: '绿地挑战',
    author: '活动策划部',
    publishDate: '2026-08-06',
    readTime: '4分钟',
    image: 'https://readdy.ai/api/search-image?query=Happy%20family%20with%20parents%20and%20children%20playing%20outdoor%20grass%20sports%20together%20in%20sunny%20park%2C%20joyful%20expressions%2C%20lush%20green%20lawn%2C%20warm%20sunlight%2C%20clean%20editorial%20style%2C%20natural%20composition&width=1200&height=600&seq=article-qinzi-01&orientation=landscape',
    tags: ['亲子', '家庭', '绿地挑战'],
  },
  {
    slug: '2026-q3-paihangbang-jiexi',
    title: '2026年第三季度排行榜深度解析：新星崛起与老将坚守',
    excerpt: '2026年第三季度排行榜新鲜出炉！本季度涌现多位实力新星，同时老将们依然稳居前列。让我们一起来看看榜单背后的故事。',
    content: `<p>2026年第三季度<strong>排行榜</strong>新鲜出炉！本季度涌现多位实力新星，同时老将们依然稳居前列。让我们一起来看看榜单背后的故事。</p>
    <h2>榜单概览</h2>
    <p>本季度共有<strong>12,850名</strong>活跃选手参与排名。前十名中出现了三位新面孔，这是近两年来人员变动最大的一个季度。</p>
    <h2>新星亮点</h2>
    <p>来自广州的<strong>陈晓峰</strong>以黑马之姿闯入前三，其独特的「双螺旋」战术引发了竞技圈的热议。来自成都的<strong>刘思雨</strong>则凭借稳定的发挥，首次进入前十。</p>
    <h2>老将动态</h2>
    <p>连续六个季度霸榜的<strong>王浩然</strong>依然稳居第一，但其与第二名之间的差距已缩小至不到5分。第三季度结束后，竞争格局将更加激烈。</p>
    <h2>排名规则说明</h2>
    <p>排行榜根据<strong>赛事积分、胜率、参赛频率</strong>三个维度综合计算。每月更新一次，季度末发布总榜。</p>`,
    category: 'zonghe-saishi',
    categoryName: '综合赛事',
    author: '数据团队',
    publishDate: '2026-08-04',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Sports%20leaderboard%20display%20on%20large%20digital%20screen%20in%20modern%20sports%20arena%2C%20athlete%20rankings%20and%20statistics%2C%20professional%20competitive%20atmosphere%2C%20clean%20minimal%20design%2C%20green%20accent%20colors&width=1200&height=600&seq=article-paihang-01&orientation=landscape',
    tags: ['排行榜', '排名', '数据分析'],
  },
  {
    slug: 'gaoji-jiqiao-shuangluoxuan',
    title: '高级技巧精讲：掌握双螺旋战术，突破竞技瓶颈',
    excerpt: '双螺旋战术是当前草类竞技中最受关注的高级技巧之一。本文由全国冠军教练亲自执笔，为你详细讲解这一战术的核心要点。',
    content: `<p><strong>双螺旋战术</strong>是当前草类竞技中最受关注的高级技巧之一。本文由全国冠军教练亲自执笔，为你详细讲解这一战术的核心要点。</p>
    <h2>什么是双螺旋战术</h2>
    <p>双螺旋战术是一种<strong>攻防一体的竞技策略</strong>，其核心在于通过快速的方向切换和节奏变化，打乱对手的预判，同时保持自身的稳定输出。</p>
    <h2>基础动作分解</h2>
    <p>双螺旋战术包含<strong>五个核心动作</strong>：螺旋起步、反向切变、重心转移、爆发突进和收尾锁定。每个动作都需要反复练习才能掌握。</p>
    <h2>训练方法</h2>
    <p>建议每天进行<strong>至少30分钟</strong>的专项训练。先从慢速分解动作开始，逐步加快速度。配合视频录制分析，可以更快发现和纠正动作偏差。</p>
    <h2>实战应用</h2>
    <p>在实战中使用双螺旋战术时，需注意<strong>时机把握</strong>和<strong>体能消耗</strong>。建议在比赛中期对手体力下降时发起攻势，效果最佳。</p>`,
    category: 'gaoji-jijie',
    categoryName: '高级技巧',
    author: '全国冠军教练 赵刚',
    publishDate: '2026-08-02',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Professional%20athlete%20demonstrating%20advanced%20sports%20technique%20on%20grass%20field%2C%20dynamic%20spiral%20motion%20captured%20mid%20action%2C%20dramatic%20lighting%2C%20clean%20background%2C%20editorial%20sports%20photography%2C%20powerful%20athletic%20pose&width=1200&height=600&seq=article-gaoji-01&orientation=landscape',
    tags: ['高级技巧', '战术', '训练'],
  },
  {
    slug: 'xinren-rumen-wu-da-jichu',
    title: '新人入门必看：草类竞技五大基础动作详解',
    excerpt: '无论你选择哪种草类竞技项目，这五大基础动作都是必不可少的。掌握它们，你就能在各类赛事中游刃有余。',
    content: `<p>无论你选择哪种草类竞技项目，这<strong>五大基础动作</strong>都是必不可少的。掌握它们，你就能在各类赛事中游刃有余。</p>
    <h2>1. 标准起步姿势</h2>
    <p>正确的起步姿势是所有动作的基础。双脚与肩同宽，膝盖微屈，重心前倾约15度，双手自然摆放于身体两侧。</p>
    <h2>2. 草地奔跑技巧</h2>
    <p>草地奔跑与硬地不同，需要<strong>更高抬腿</strong>和<strong>更短步幅</strong>。保持脚掌中部着地，避免脚跟先着地造成的能量损失。</p>
    <h2>3. 急停转向</h2>
    <p>掌握急停转向可以在比赛中获得巨大的机动优势。关键在于<strong>降低重心</strong>和<strong>利用草地的摩擦力</strong>。</p>
    <h2>4. 弹跳发力</h2>
    <p>草地的弹性为弹跳提供了天然的助力。正确利用草地的反弹特性，可以显著提升跳跃高度和距离。</p>
    <h2>5. 安全落地</h2>
    <p>安全落地是最容易被忽视但最重要的技能。学习<strong>滚动卸力</strong>技巧，可以有效预防运动损伤。</p>`,
    category: 'xinren-rumen',
    categoryName: '新人入门',
    author: '培训总监 张华',
    publishDate: '2026-08-01',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Coach%20demonstrating%20basic%20sports%20movements%20to%20group%20of%20beginners%20on%20green%20grass%20field%2C%20instructional%20training%20session%2C%20bright%20sunny%20day%2C%20clean%20editorial%20photography%2C%20supportive%20learning%20environment&width=1200&height=600&seq=article-jichu-01&orientation=landscape',
    tags: ['新人入门', '基础动作', '训练'],
  },
  {
    slug: 'caodi-jingji-anquan-shouze',
    title: '草地竞技安全守则：每位选手都必须了解的防护知识',
    excerpt: '安全第一，比赛第二。这份草地竞技安全守则汇总了最常见的运动损伤类型和预防措施，请务必在参赛前仔细阅读。',
    content: `<p>安全第一，比赛第二。这份<strong>草地竞技安全守则</strong>汇总了最常见的运动损伤类型和预防措施，请务必在参赛前仔细阅读。</p>
    <h2>常见运动损伤</h2>
    <p>草地竞技中最常见的损伤包括<strong>踝关节扭伤</strong>（占比35%）、<strong>肌肉拉伤</strong>（占比28%）和<strong>膝关节损伤</strong>（占比18%）。大多数损伤可以通过正确的预防措施避免。</p>
    <h2>赛前准备清单</h2>
    <p>每次参赛前请确认以下事项：充分热身（至少20分钟）、检查装备完好性、了解天气和场地状况、确保充足的水分和能量补给。</p>
    <h2>比赛中的注意事项</h2>
    <p>比赛中如感到<strong>异常疼痛</strong>或<strong>头晕目眩</strong>，应立即停止比赛并寻求医疗帮助。不要因为竞技压力而忽视身体发出的警告信号。</p>
    <h2>赛后恢复</h2>
    <p>比赛结束后进行<strong>15分钟的整理运动</strong>，包括轻度拉伸和慢走。24小时内可进行冰敷处理，48小时后可转为热敷促进恢复。</p>`,
    category: 'caodi-jingji',
    categoryName: '草地竞技',
    author: '运动医学专家 王医生',
    publishDate: '2026-07-28',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Sports%20safety%20training%20session%20on%20grass%20field%20with%20medical%20staff%20demonstrating%20first%20aid%20techniques%2C%20protective%20gear%20displayed%2C%20professional%20healthcare%20setting%2C%20clean%20bright%20environment&width=1200&height=600&seq=article-anquan-01&orientation=landscape',
    tags: ['安全', '防护', '健康'],
  },
  {
    slug: 'zonghe-saishi-jifen-guize',
    title: '综合赛事积分规则全面解读：2026年最新版',
    excerpt: '2026年综合赛事积分规则进行了多项调整。本文详细解读新规则下的积分计算方式、排名机制和奖励分配，助你精准规划参赛策略。',
    content: `<p>2026年<strong>综合赛事积分规则</strong>进行了多项调整。本文详细解读新规则下的积分计算方式、排名机制和奖励分配。</p>
    <h2>积分计算变化</h2>
    <p>新规则将<strong>赛事难度系数</strong>纳入积分计算。高难度赛事的积分权重提升至1.5倍，这意味着参加高级别赛事可以获得更多积分。</p>
    <h2>连胜奖励机制</h2>
    <p>新增<strong>连胜加成</strong>：连续3场获胜额外获得10%积分加成，5场连胜加成20%，10场以上连胜加成30%。</p>
    <h2>排名更新频率</h2>
    <p>排名从原来的每月更新调整为<strong>每周更新</strong>，让选手能更及时地了解自己的竞技状态和排名变化。</p>
    <h2>奖励分配调整</h2>
    <p>奖金池分配比例从原来的前10名扩展至<strong>前50名</strong>，鼓励更多选手参与竞争。同时增设「最佳进步奖」和「最佳新人奖」两个特别奖项。</p>`,
    category: 'zonghe-saishi',
    categoryName: '综合赛事',
    author: '赛事规则委员会',
    publishDate: '2026-07-25',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Sports%20scoreboard%20and%20ranking%20system%20displayed%20on%20modern%20digital%20interface%2C%20clean%20data%20visualization%2C%20green%20and%20gold%20accent%20colors%2C%20professional%20design%2C%20minimal%20layout&width=1200&height=600&seq=article-jifen-01&orientation=landscape',
    tags: ['积分规则', '排名', '赛事'],
  },
];

export const getArticleBySlug = (slug: string) => {
  return articles.find((a) => a.slug === slug) || null;
};

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getRecentArticles = (count: number = 6) => {
  return [...articles].sort((a, b) => b.publishDate.localeCompare(a.publishDate)).slice(0, count);
};